import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { LegalPage } from "@/components/pages/LegalPage";
import { nl } from "@/i18n/nl";

export const Route = createFileRoute("/nl/wettelijke-vermeldingen")({
  head: () =>
    buildHead({
      lang: "nl",
      page: "home",
      title: nl.legal.page.title + " · 2AM Hospitality",
      description: nl.legal.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "nl") i18n.changeLanguage("nl");
    }, []);
    if (i18n.language !== "nl") i18n.changeLanguage("nl");
    return <LegalPage />;
  },
});
